import {sounds} from "./sound"

export const SoundsCardMap = {
    1043: function () {
        return sounds.battle_play_air_mana()
    },
    1042: function () {
        return sounds.battle_play_fire_mana()
    },
    1044: function () {
        return sounds.battle_play_earth_mana()
    },


    1047: function () {
        return sounds.acid_spores()
    },
    1027: function () {
        return sounds.desperate_passion()
    },
    1028: function () {
        return sounds.slave()
    },
    1029: function () {
        return sounds.victim()
    },
    1030: function () {
        return sounds.spikes_love()
    },
    1031: function () {
        return sounds.dickfither()
    },
    1032: function () {
        return sounds.henchman()
    },
    1033: function () {
        return sounds.knighthood()
    },
    1034: function () {
        return sounds.blessing()
    },
    1035: function () {
        return sounds.horsewoman()
    },
    1036: function () {
        return sounds.mad()
    },
    1037: function () {
        return sounds.fire_bolt()
    },
    1038: function () {
        return sounds.cat_girl()
    },
    1039: function () {
        return sounds.lightning()
    },
    1040: function () {
        return sounds.dragon_girl()
    },
    1041: function () {
        return sounds.gabriela()
    },
    1046: function () {
        return sounds.wall_of_fire()
    },
    1048: function () {
        return sounds.zombie_wizard()
    },
    1049: function () {
        return sounds.fire_elemental()
    },
    1050: function () {
        return sounds.spark_summon()
    },
    1051: function () {
        return sounds.blast()
    },
    1053: function () {
        return sounds.air_elemental()
    },
    1054: function () {
        return sounds.cloud()
    },
    1055: function () {
        return sounds.chain_lightning()
    },
    1057: function () {
        return sounds.fairy()
    },
    1058: function () {
        return sounds.hurricane()
    },
    1059: function () {
        return sounds.earth_elemental()
    },
    1060: function () {
        return sounds.healing_potion()
    },
    1061: function () {
        return sounds.sword()
    },
    1062: function () {
        return sounds.shield()
    },
    1063: function () {
        return sounds.troll()
    },
    1064: function () {
        return sounds.port_rats()
    },
    1065: function () {
        return sounds.thief()
    },
    1066: function () {
        return sounds.kailis()
    },
    1067: function () {
        return sounds.robbery()
    },
    1068: function () {
        return sounds.riot()
    },
    1070: function () {
        return sounds.lamia()
    },
    1154: function () {
        return sounds.lamia()
    },
    1069: function () {
        return sounds.kailis_heretic()
    },
    1071: function () {
        return sounds.amulet_of_death()
    },
    1072: function () {
        return sounds.wrath_old_god()
    },
    1073: function () {
        return sounds.chimera()
    },
    1083: function () {
        return sounds.tentacles()
    },
    1096: function () {
        return sounds.troll_guard()
    },
    1088: function () {
        return sounds.stun()
    },
    1090: function () {
        return sounds.orkSword()
    },
    1091: function () {
        return sounds.orkArmor()
    },
    1089: function () {
        return sounds.uin()
    },
    1101: function () {
        return sounds.bite()
    },
    1102: function () {
        return sounds.vampire_repast()
    },
    1099: function () {
        return sounds.vampires()
    },
    1115: function () {
        return sounds.treasure()
    },
    1116: function () {
        return sounds.ball_lighting()
    },
    1117: function () {
        return sounds.shackles()
    },
    1121: function () {
        return sounds.sirenes()
    },
    1123: function () {
        return sounds.bomb()
    },
    1150: function () {
        return sounds.bomb()
    },
    //1125:function () {return sounds.rat()}, double with middleware
    1126: function () {
        return sounds.bottle()
    },
    1127: function () {
        return sounds.splash()
    },
    1136: function () {
        return sounds.mermeid()
    },
    1137: function () {
        return sounds.slime()
    },
    1140: function () {
        return sounds.treasures()
    },
    1163: function () {
        return sounds.blood_chain()
    },
    1164: function () {
        return sounds.plague()
    },
    1157: function () {
        return sounds.slime_bubble()
    },
    '1165-cometExplosion' : function () {
        return sounds.blast()
    },
    '1165-CurseDebuff' : function () {
        return sounds.sucrifice()
    },
    '1166-CurseDebuff' : function () {
        return sounds.sucrifice()
    },
    '1167-CurseDebuff' : function () {
        return sounds.sucrifice()
    },
    1045: function () {
        return sounds.zombie()
    },
}
